var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: _vm.size,
        height: _vm.size,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("rect", {
        attrs: { x: "6", y: "6", width: "11", height: "11", fill: _vm.color }
      }),
      _c("path", {
        attrs: {
          d:
            "M18.5408 4.17001L13.0408 2.11001C12.4708 1.90001 11.5408 1.90001 10.9708 2.11001L5.47078 4.17001C4.41078 4.57001 3.55078 5.81001 3.55078 6.94001V15.04C3.55078 15.85 4.08078 16.92 4.73078 17.4L10.2308 21.51C11.2008 22.24 12.7908 22.24 13.7608 21.51L19.2608 17.4C19.9108 16.91 20.4408 15.85 20.4408 15.04V6.94001C20.4508 5.81001 19.5908 4.57001 18.5408 4.17001ZM12.0008 16.25C9.38078 16.25 7.25078 14.12 7.25078 11.5C7.25078 8.88001 9.38078 6.75001 12.0008 6.75001C14.6208 6.75001 16.7508 8.88001 16.7508 11.5C16.7508 14.12 14.6208 16.25 12.0008 16.25Z",
          fill: _vm.color
        }
      }),
      _c("g", { attrs: { "clip-path": "url(#" + _vm.clipId + ")" } }, [
        _c("path", {
          attrs: {
            d:
              "M12 14.0233C13.3898 14.0233 14.5116 12.9014 14.5116 11.5116C14.5116 10.1219 13.3898 9 12 9C10.6102 9 9.48837 10.1219 9.48837 11.5116C9.48837 12.9014 10.6102 14.0233 12 14.0233Z",
            fill: _vm.colorInternal
          }
        }),
        _c("path", {
          attrs: {
            d:
              "M10.8837 11.9302H6.4186C6.18977 11.9302 6 11.7405 6 11.5116C6 11.2828 6.18977 11.093 6.4186 11.093H10.8837C11.1126 11.093 11.3023 11.2828 11.3023 11.5116C11.3023 11.7405 11.1126 11.9302 10.8837 11.9302Z",
            fill: _vm.colorInternal
          }
        }),
        _c("path", {
          attrs: {
            d:
              "M17.5814 11.9302H13.1163C12.8874 11.9302 12.6977 11.7405 12.6977 11.5116C12.6977 11.2828 12.8874 11.093 13.1163 11.093H17.5814C17.8102 11.093 18 11.2828 18 11.5116C18 11.7405 17.8102 11.9302 17.5814 11.9302Z",
            fill: _vm.colorInternal
          }
        })
      ]),
      _c("defs", [
        _c("clipPath", { attrs: { id: _vm.clipId } }, [
          _c("rect", {
            attrs: {
              width: "12",
              height: "5.02326",
              fill: _vm.colorInternal,
              transform: "translate(6 9)"
            }
          })
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }